module.exports = __webpack_public_path__ + "static/media/services-bg-2.09e83bfd.avif";